import { 
  Megaphone, Mail, BookOpen, Presentation, Video, MessageSquare, 
  Target, Rocket, FileText, LineChart, Settings, Share2
} from 'lucide-react';
import { AppTool } from '../../components/workspace/ToolWidget';

export const GrowthToolsRegistry: AppTool[] = [
  // Marketing & Campaigns
  { id: 'gro-campaigns', name: 'Campaigns', description: 'Manage multi-channel marketing campaigns.', icon: Megaphone, path: '/growth/campaigns', category: 'Marketing', badge: 'Popular' },
  { id: 'gro-email', name: 'Email Marketing', description: 'Design and send newsletters and sequences.', icon: Mail, path: '/growth/email', category: 'Marketing' },
  { id: 'gro-social', name: 'Social Media', description: 'Schedule and track social media posts.', icon: Share2, path: '/growth/social', category: 'Marketing' },
  
  // Sales & Leads
  { id: 'gro-leads', name: 'Leads Pipeline', description: 'Track MQLs and SQLs through the funnel.', icon: Target, path: '/growth/leads', category: 'Sales' },
  { id: 'gro-opportunities', name: 'Opportunities', description: 'High-value deals and account expansions.', icon: Rocket, path: '/growth/opportunities', category: 'Sales' },
  
  // Content & Enablement
  { id: 'gro-wiki', name: 'Wiki', description: 'Company knowledge base and playbooks.', icon: BookOpen, path: '/growth/wiki', category: 'Enablement' },
  { id: 'gro-meetings', name: 'Webinars', description: 'Host and track webinar attendance.', icon: Video, path: '/growth/webinars', category: 'Enablement' },
  { id: 'gro-presentations', name: 'Presentations', description: 'Sales decks and pitch templates.', icon: Presentation, path: '/growth/presentations', category: 'Enablement' },
  
  // Analytics
  { id: 'gro-reports', name: 'Reports', description: 'Conversion rates, CAC, and ROI metrics.', icon: LineChart, path: '/growth/reports', category: 'Analytics & Admin' },
  { id: 'gro-settings', name: 'Settings', description: 'Configure integrations and tracking pixels.', icon: Settings, path: '/growth/settings', category: 'Analytics & Admin' }
];
